import { useCallback } from 'react';
import { useTracking } from '@edreamsodigeo/frontend-core';

const CATEGORY = 'flights_summary';
const ACTION = 'hotels_in_flights';

const useGoogleAnalyticsTracking = () => {
  const { trackEvent } = useTracking();

  const trackOnLoad = useCallback(() => {
    trackEvent({
      category: CATEGORY,
      action: ACTION,
      label: 'hotels-in-flights_onload_pag:summary',
    });
  }, [trackEvent]);

  const trackClick = useCallback(() => {
    trackEvent({
      category: CATEGORY,
      action: ACTION,
      label: 'hotels-in-flights_click_pag:summary',
    });
  }, [trackEvent]);

  return {
    trackOnLoad,
    trackClick,
  };
};

export default useGoogleAnalyticsTracking;
